import { Question, QuestionAttributeOptions, QuestionType } from '@reviews/interfaces';
import * as _ from 'lodash';

/**
 * Maps Formik field values into survey_response_answers for POST /surveys.
 * Field names use `{questionId}-{category}-{type}-{attribute}` (e.g. `12-DIGITAL_CONTENT-COMMENT-answer`).
 */
export const buildSurveyResponseAnswers = (
    values: { [key: string]: any },
    rawQuestions: Array<Question>
): Array<{
    question_id: number;
    type: string;
    answer: { dismissed: boolean; data: any };
}> => {
    const keys = _.keys(values);
    const mapAnswers: { [key: string]: any } = {};

    for (const key of keys) {
        const [questionId, _name, type, attribute] = key.split('-');
        const question_id = +questionId;
        const isDismissed = attribute === QuestionAttributeOptions.DISMISSED || mapAnswers[question_id]?.answer.dismissed;

        if (!mapAnswers[question_id]) {
            mapAnswers[question_id] = {
                question_id,
                type,
                answer: {
                    dismissed: false,
                    data: {},
                },
            };
        }
        if (isDismissed) {
            mapAnswers[question_id].answer.dismissed = isDismissed;
            mapAnswers[question_id].answer.data = null;
        } else if (type === QuestionType.PHOTO && attribute === 'answer') {
            mapAnswers[question_id].answer.data = {
                photos: values[key] || [],
            };
        } else if (type === QuestionType.COMMENT && attribute === 'answer') {
            const text = values[key];
            mapAnswers[question_id].answer.data = _.isEmpty(_.trim(text || '')) ? null : { answer: text };
        } else {
            mapAnswers[question_id].answer.data = {
                [attribute]: type === QuestionType.RATING && attribute === 'answer' ? +values[key] : values[key],
                ...(mapAnswers[question_id].answer.data || {}),
            };
        }
    }

    for (const question of rawQuestions) {
        const { question_id, required, type } = question;
        if (!mapAnswers[question_id]) {
            mapAnswers[question_id] = {
                question_id: +question_id,
                type,
                answer: {
                    dismissed: false,
                    data: type === QuestionType.PHOTO ? { photos: [] } : null,
                },
            };

            if (required) {
                console.debug(
                    `question ${question_id} of type ${type} is required but doesn't have an answer. Validations may have failed`
                );
            }
        }
    }

    return _.values(mapAnswers);
};
